import { db } from '../firebase';
import { collection, addDoc } from '../firestore-compat';

/**
 * Notifies participants about a change in date or time of an event.
 * 
 * @param {Object} eventoOriginal - The event data before changes.
 * @param {Object} dadosAtualizados - The new event data.
 * @param {string} currentUserName - The name of the person making the change.
 * @param {string} collectionName - The source collection name.
 */
export async function notifyParticipantsOfChange(eventoOriginal, dadosAtualizados, currentUserName, collectionName) {
    // Only notify if date or time changed
    const dateChanged = dadosAtualizados.data && dadosAtualizados.data !== eventoOriginal.data;
    const timeChanged = dadosAtualizados.horario && dadosAtualizados.horario !== eventoOriginal.horario;

    if (!dateChanged && !timeChanged) return;

    // Get all unique participants (Uids) to notify, including those who accepted
    const uids = new Set([
        ...(eventoOriginal.participantesUids || []),
        ...(eventoOriginal.aceitePorUids || []) // FIX: Include people who accepted string invites
    ]);
    if (eventoOriginal.userId) uids.add(eventoOriginal.userId);
    if (eventoOriginal.criadoPorUid) uids.add(eventoOriginal.criadoPorUid); // In case the creator is not the one changing it

    // Remove the person who is making the change from the notification list
    // (We don't know their UID here easily, but we can assume they don't need a notification)

    // Send notifications
    const notificationPromises = [];
    uids.forEach(uid => {
        // Simple heuristic: if we have a current user UID, we'd skip it. 
        // For now, we'll just send to everyone and let the UI handle filtering if needed,
        // or just accept that the person changing it might see a notification (unlikely if they are the one doing it).

        notificationPromises.push(addDoc(collection(db, 'notificacoes'), {
            tipo: 'alteracao_agendamento',
            destinatarioUid: uid,
            lida: false,
            dataNotificacao: new Date().toISOString(),

            // Details of the change
            eventoId: eventoOriginal.id,
            eventoTitulo: eventoOriginal.descricao || eventoOriginal.auditoria || 'Evento',
            dataAntiga: eventoOriginal.data,
            horarioAntigo: eventoOriginal.horario,
            dataNova: dadosAtualizados.data || eventoOriginal.data,
            horarioNovo: dadosAtualizados.horario || eventoOriginal.horario,
            alteradoPor: currentUserName,
            collectionSource: collectionName
        }));
    });

    try {
        await Promise.all(notificationPromises);
        console.log(`[NOTIFY] Sent ${notificationPromises.length} notifications for event change.`);
    } catch (error) {
        console.error('[NOTIFY] Error sending change notifications:', error);
    }
}
